import React, { FunctionComponent, useState } from 'react';
import { withApiData, ApiDataBinding } from 'react-api-data';
import { compose } from 'recompose';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';
import get from 'lodash/get';

// constants
import { Account, ReactApiDataActions, User } from 'constants/api';

// components
import Tooltip from 'components/utils/Tooltip';
import FormModal from './FormModal';

interface InputProps {
    uuid: string;
    contractUuid: string;
    account: Account;
}

interface EnhanceProps {
    deleteAccount: ApiDataBinding<User>;
    apiDataActions: ReactApiDataActions;
}

type Props = EnhanceProps & InputProps & WithTranslation;

const enhance = compose<Props, InputProps>(
    withApiData({
        deleteAccount: 'deleteAccount',
    }),
    withTranslation()
);

const AccountDeleteModal: FunctionComponent<Props> = ({ deleteAccount, account, contractUuid, apiDataActions, t }) => {
    const [isOpen, setIsOpen] = useState(false);
    const username = get(account.user, 'email');

    function toggle() {
        setIsOpen((isOpen) => !isOpen);
    }
    function onSubmit() {
        return deleteAccount.perform({
            accountUuid: account.uuid,
            contractUuid,
        });
    }

    function onSucces() {
        const requestParams = { contractUuid } ;
        apiDataActions.invalidateCache('getContractAccounts', requestParams);
        apiDataActions.perform('getContractAccounts', requestParams);
    }

    return (
        <React.Fragment>
            <FormModal
                header={t('deleteAccountModal.headerTitle')}
                isOpen={isOpen}
                toggle={toggle}
                initialValues={{}}
                onSubmit={onSubmit}
                onSuccess={onSucces}
                successMessage={t('notification.deleteAccountSuccessful')}
            >
                {() => (
                    <React.Fragment>
                        <Trans i18nKey="deleteAccountModal.bodyMessage">
                            <strong>{{ username }}</strong>
                        </Trans>
                    </React.Fragment>
                )}
            </FormModal>
            <Tooltip
                data-test="user-delete-btn"
                triggerBtn={
                    <i className="fas fa-trash fa-pull-right mt-1 cursor-pointer text-primary" onClick={toggle} />
                }
            >
                {t('deleteAccountModal.headerTitle')}
            </Tooltip>
        </React.Fragment>
    );
};

export default enhance(AccountDeleteModal);
